import {Tabs} from 'antd';
import {ExistingPurchaseOrderView} from "./ExistingPurchaseOrderView";
import {RequestedItems} from "./RequestedItems";
import {TaskTable} from "../tasks/TaskTable";
import {checkPerm} from "../../auth/sessionTools";

export const FulfillmentTab = ({session, refresh, onRefresh, onApiFail, props}) => {

    const hasAllTasks = checkPerm(session, "allTask");
    const items = [
        {
            key: 'ExistingPurchaseOrders',
            label: 'Existing Purchase Orders',
            children: <ExistingPurchaseOrderView onApiFail={onApiFail} refresh={refresh} onRefresh={onRefresh} />
        },
        {
            key: 'RequestedProducts',
            label: 'Requested Products',
            children: <RequestedItems onApiFail={onApiFail} refresh={refresh} onRefresh={onRefresh} />
        },
    ];

    if (hasAllTasks) {
        items.push({
            key: 'DepartmentTasks',
            label: 'Fulfillment Tasks',
            children: <TaskTable refresh={refresh} onApiFail={onApiFail} taskType={'department'} showVerified={false} department={`Fulfillment`} />
        });
    }

    return <Tabs tabPosition={'left'} defaultActiveKey={'ExistingPurchaseOrders'} items={items} />
}